// CustomerLayout.tsx
import React, {FormEvent, useState} from 'react';
import {AppShell, Burger, Button, Flex, Image, Menu, Notification} from '@mantine/core';
import {Routes, Route, Navigate, useNavigate} from 'react-router-dom';
import {Navigation} from "./Navigation";
import {useDisclosure} from "@mantine/hooks";
import {getToken, removeToken} from "../../../auth/service/authService";
import {Overview} from "../Overview";
import {Contracts} from "../Contracts";
import {Templates} from "../Templates";
import logo from '../../../util/logo.png'
import DatenschutzErklaerung from "../../../ui/information/lawstuff/Datenschutz";
import AGB from "../../../ui/information/lawstuff/AGB";
import Impressum from "../../../ui/information/lawstuff/Impressum";
import {
    IconArrowsLeftRight,
    IconLock
} from "@tabler/icons-react";
import axios from "axios";
import {BackendUrl} from "../../../util/config";
import {jwtDecode} from "jwt-decode";


export const CustomerLayout: React.FC = () => {

    const navigate = useNavigate()

    const token = getToken()

    const [message, setMessage] = useState<String | null>(null);
    const [error, setError] = useState<String | null>(null);

    const [mobileOpened, { toggle: toggleMobile }] = useDisclosure();
    const [desktopOpened, { toggle: toggleDesktop }] =
        useDisclosure(true);

    const handleLogout =() => {
        removeToken();
        navigate("/login");
    }

    const handleResetPassword = async (e: FormEvent) => {
        e.preventDefault();
        if(token){
            const email = jwtDecode(token).sub
            try {
                const response = await axios.post(BackendUrl + '/auth/forgot-password', { email });
                setMessage(response.data.message);
            } catch (err: any) {
                setError(err.response?.data?.error || 'Something went wrong');
            }
        }

    };

    return (
        <AppShell
            navbar={{
                width: 300,
                breakpoint: 'sm',
                collapsed: { mobile: !mobileOpened, desktop: !desktopOpened },
            }}
        >
            <AppShell.Header >
                <Flex align={"center"} justify={"space-between"} h={"100%"} p={"sm"}>
                    <Flex align={"center"} gap={"sm"}>
                        {/* Error message */}
                        {error && (
                            <Notification color="red" onClose={() => setError(null)} mb="md">
                                {error}
                            </Notification>
                        )}

                        {/* Success message */}
                        {message && (
                            <Notification color="teal" onClose={() => setMessage(null)} mb="md">
                                {message}
                            </Notification>
                        )}
                        <Burger
                            opened={mobileOpened}
                            onClick={toggleMobile}
                            hiddenFrom="sm"
                            size="sm"
                        />
                        <Burger
                            opened={desktopOpened}
                            onClick={toggleDesktop}
                            visibleFrom="sm"
                            size="sm"
                        />
                        <Image
                            h={40}
                            radius="md"
                            src={logo}
                        />
                    </Flex>
                    <Menu shadow="md" width={200}>
                        <Menu.Target>
                            <Button variant={"light"}>Nutzerkonto</Button>
                        </Menu.Target>

                        <Menu.Dropdown>


                            <Menu.Label>Danger zone</Menu.Label>
                            <Menu.Item
                                leftSection={<IconArrowsLeftRight size={14} />}
                                onClick={handleResetPassword}
                            >
                                Passwort ändern
                            </Menu.Item>
                            <Menu.Item
                                color="red"
                                leftSection={<IconLock size={14} />}
                                onClick={handleLogout}
                            >
                                Abmelden
                            </Menu.Item>
                        </Menu.Dropdown>
                    </Menu>
                </Flex>


            </AppShell.Header>
            <Navigation></Navigation>
            <AppShell.Main>
                <Routes>
                    {/* Customer main or “dashboard” */}
                    <Route path="/overview" element={<Overview />} />
                    <Route path="/contracts" element={<Contracts />} />
                    <Route path="/templates" element={<Templates />} />
                    {/* You can add other customer-specific routes here if needed */}
                    {/* e.g. <Route path="/my-invoices" element={<MyInvoices />} /> */}

                    <Route path="/datenschutzerklärung" element={<DatenschutzErklaerung />} />
                    <Route path="/agb" element={<AGB />} />
                    <Route path="/impressum" element={<Impressum />} />


                    {/* Catch-all: if no match, redirect to the main page */}
                    <Route path="*" element={<Navigate to="/overview" />} />
                </Routes>
            </AppShell.Main>

        </AppShell>
    );

};
